import { RefObject, useEffect } from 'react';
import { useSpring } from 'react-spring';

export const useScroll = ({
  container,
}: {
  container: RefObject<HTMLElement>;
}) => {
  const [scrollValues, api] = useSpring(() => ({
    from: {
      scrollX: 0,
      scrollY: 0,
    },
  }));

  useEffect(() => {
    const onScroll = () => {
      api.start({
        scrollX: container.current?.scrollLeft,
        scrollY: container.current?.scrollTop,
      });
    };
    const containerRef = container.current;
    containerRef?.addEventListener('scroll', onScroll);
    return () => {
      containerRef?.removeEventListener('scroll', onScroll);
    };
  }, [container, api]);

  return scrollValues;
};
